
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as blankNWz6RyizCRaCbXriEhBAKxa3m7iefictAro6NsXRE8kMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/blank.vue?macro=true";
import { default as errortIVDwsmpKuX_EzTk3GkvrZDn2WhKRC_45GDKdpJZpS3ZYMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/error.vue?macro=true";
import { default as indexzAeX_45uUFu8WliSAxGdQNlA78l_11wyiKVYGU0mWqhP8Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/index.vue?macro=true";
import { default as login3RcehSFFGF6tPwZFpA0pUO0moEP4E_sXB0vXsZORpmkMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/login.vue?macro=true";
import { default as logoutU1hgNbZ8JIIq0a7NChO12A2VBweTd_T4hRJ1OQYiVuUMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/logout.vue?macro=true";
import { default as indexslj_453m_tT0nXHTS5_45n80uXgHJZH4WFJ_4564jswhtTvnYMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/index.vue?macro=true";
import { default as indexs5kfPYCj_jpjQ2jUXEYk1Rv68GsvVWJrDXI7qN9sQP8Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/index.vue?macro=true";
import { default as leaderboard7kru2bwexjVSLutR8iQ2we_45T76lSG78h4HK9ChzRQLkMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/leaderboard.vue?macro=true";
import { default as brandsih5twTg_45g0QPmeaMZQf7bwQWnZa3UNU1iqQVLFZ7OzEMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/brands.vue?macro=true";
import { default as newNdsL_45WHOwDhDBDaamMs_B3C_45fAkNhxqqYPg3UUIHmtUMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/new.vue?macro=true";
import { default as contactrZPrPMWWdU6lSDjspbMkL4tVGtwqZ0Lj73LJ9yJ0ryQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/contact.vue?macro=true";
import { default as expertsklgonGCPDPTq_455E0AGT9SLUGXWAKFrkTzxswWf99feoMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/experts.vue?macro=true";
import { default as indexk1rNThBTT7S5vTcZTvKhDZTGsG397r6kOrFYpXY7StwMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/meetups/index.vue?macro=true";
import { default as indexwUUcIu8_9ontpo_45wi8eJu5xrIlS4tJ2IRY_g49qYGP4Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/index.vue?macro=true";
import { default as creatorssrHiveAa9aWnY4T42US8lTAznVLRLOOgDcpM1Z9dE4cMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/creators.vue?macro=true";
import { default as indexutu1jmF6lUpEXyyqoyIFJpdL5ksSfPkg898h1qDW3JMMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/exercise/index.vue?macro=true";
import { default as indexW_45PDoQEB3J_cTlkr5_d7LLWWG80Y7XkcFJPEHCgPMLwMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/index.vue?macro=true";
import { default as index3THK_fysL7Qtec9pqU8bpJjC8USQ3trisF25jW79ZygMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/password/index.vue?macro=true";
import { default as index1fYaROyv569F88LeQUAapdLJbodSeSwX_45EOcYZP2mEoMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/index.vue?macro=true";
import { default as indexb_hyTqqrdsIXPAPbtkQc5FZPkRcBrrfVKGRff_fJWAoMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/register/index.vue?macro=true";
import { default as mbgPThxXeEf5Az_Li9hZebHmM3IXE4bFg1X_45wH1dL0bARQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/mbg.vue?macro=true";
import { default as verifyTHXxRr5hiYOxrNqwgojNZppSTq_457U_ca1zs8vZo9G8kMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/password/verify.vue?macro=true";
import { default as zotrimqqSiyzfIFOqeM_PLEGA4chzGzcYtw_ENtEUJOmnTKG0Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/zotrim.vue?macro=true";
import { default as verify7nwnVN0KsQk_WeBzOtLEll6Uu69bQVhmhtARCCVbaVAMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/register/verify.vue?macro=true";
import { default as affiliates4YXVkvcavyc36mPK3oui6j0PfoifcCBykVkoCdH_453icMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/affiliates.vue?macro=true";
import { default as index3WGh_itYY4sjRPaRQfW8gZ9tfxE0UwwMU2Jm9FewHJ4Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/challenges/index.vue?macro=true";
import { default as request8mLWZcnV9ynjS3tRj3DMyXUxeqV1CQekJBY3aEU4F8gMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/request.vue?macro=true";
import { default as indexc2hwYUOa9WxmZPLKtZPzgKSLnCgP7oWHl0bA2O3KsQsMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/index.vue?macro=true";
import { default as indexaBxmJ10Ttm61xyHmk16nlr5slKEDSY9zmaXKoIJrb28Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/users/index.vue?macro=true";
import { default as index8zdVAUBylxdVki7HUHmSgCuPg1vO_4549RZGjscvuYDmQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/index.vue?macro=true";
import { default as phengold4wKGZ6qaGSZboRgLiqaGCDOIhbxMyc6fEGdCOUQq6ZYMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/phengold.vue?macro=true";
import { default as testogenWD44BDQbMczxayUk7O43tiorN_YrW7Psf_M25tkqZ1IMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/testogen.vue?macro=true";
import { default as trimtoneqAcgIrYJURqot2snGrsxwwqDG7uTgRRpXn_45WR8m8BI8Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/trimtone.vue?macro=true";
import { default as cancelKebXwhIBfsvDGdTezrvuiiPDGSpvUZWjOP6Td_AiVnAMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/cancel.vue?macro=true";
import { default as refundF_45fnEZ_45SmimFNixslCxS2kmYs_bp56AufH3zdaUZvbQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/refund.vue?macro=true";
import { default as createAsgtCbYvpApTM54MQZ2Rvo_45igUmP0sOF8BVB3Z7JghgMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/users/create.vue?macro=true";
import { default as blackwolftcZWNpbUvo_45AE9h4Kl8_OIng_451sLu6hzcI7ZH6SN1hQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/blackwolf.vue?macro=true";
import { default as privacynqR0ju7nfVcVFlF_45rAyOOM5bWX2qEyVVzZYe1FHJN5cMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/privacy.vue?macro=true";
import { default as indexyp520tKjo9qBOZmOPETDP1gzIDXE0ybohEQerF3OpSAMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/reviews/index.vue?macro=true";
import { default as berbaprimeQdrcLx2wisjsMhLRdqYJnUl8Ss0huRR8x4ZPsdCxwSAMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/berbaprime.vue?macro=true";
import { default as primeshredxF3vveJA4KiPSF9wrYf5smEL77vr8lkNsw8rhpWl0RMMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/primeshred.vue?macro=true";
import { default as shipping6hlwdVldlJA_45DVRj8FsGAjpAZ15EKSiMfm5g18gpp70Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/shipping.vue?macro=true";
import { default as createDxyJ7cGAf7FA4owwtVGrGxM3Fogl7J7QjTOrI_87dBsMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/reviews/create.vue?macro=true";
import { default as indexmueC25Ox4gM4S2O5vJDU4Tt1CEAfWM4K30Dah0fHO84Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/redirects/index.vue?macro=true";
import { default as mindvitalityZgRsA7rd_45pf6DGM3_yQZU6ftAoOaKKUnqCazBzJk6p8Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/mindvitality.vue?macro=true";
import { default as notificationsRdsFkHg5SBAqM6lg8TO2dg3G7v8WVAv_45VB_4MF2Sfq4Meta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/notifications.vue?macro=true";
import { default as create_453ghs4ujRaaWZSufz_ZsuwX_45Q7XuVsm0zUkAH3_458GIcMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/redirects/create.vue?macro=true";
import { default as subscriptions_45faqIu1n_5ochGhBsY9Hd5Ex8KNqreLnrYlqjVn7fpPuvfMMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue?macro=true";
import { default as newZeS7x8hjIuKiiB2_l1cgfbmH_45uHNRfE274VPJz7k9AkMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue?macro=true";
import { default as _91id_93Uw3C32EhUOrgNjHItrup8oMzsdF6f8N41PXw_xitzaQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue?macro=true";
import { default as indexJJO5DjOGM6wn5dzCmTZosTLscvxHQhr4Mig77EP9_45mcMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/[username]/index.vue?macro=true";
import { default as subscriptionsGMCFKRi36urov3w3zeT9f_45yVV6B_451soI063lZ8mV8VYMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue?macro=true";
import { default as indexSpYGNo_iXEeZZG0x_Uirhlxt8aZI3bv9MpD_Av89aEEMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue?macro=true";
import { default as _91_46_46_46product_93ejS0YmZGYXlsCN7OpBn5sxdao4rTYuOLhqqNsWxTjJsMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/buy/[...product].vue?macro=true";
import { default as indexfjOYqQG53UNqr93qsg94biTQ7irgKy_45nfOAp7OjAwAkMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue?macro=true";
import { default as indexm14p4Cxzyv3nefsLj9Ubs2LkSxxRRpaf7xQ3nd1_F_UMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/index.vue?macro=true";
import { default as index_bx0H4veukaZXfexEUp_458KAp_45scEvpsI_5Q_45QLF6KmgMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue?macro=true";
import { default as _91article_93V_cGmIyMlkrLLqaN2jherBz32t2LtPtS2TPpJpDa7jgMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue?macro=true";
import { default as index2zDMmuZAQA1XM9I6KVCKc_45M70QUxU0OperDQmH_45B5PUMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue?macro=true";
import { default as reviewsgpHsoZwY9VMtNroJJfuBImq427_brkBZ6eAX4sp5CWQMeta } from "/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue?macro=true";
export default [
  {
    name: "blank",
    path: "/blank",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/blank.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/logout.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/index.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/leaderboard.vue")
  },
  {
    name: "about-brands",
    path: "/about/brands",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/brands.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/new.vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/contact.vue")
  },
  {
    name: "about-experts",
    path: "/about/experts",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/experts.vue")
  },
  {
    name: "meetups",
    path: "/meetups",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/meetups/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/index.vue")
  },
  {
    name: "about-creators",
    path: "/about/creators",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/creators.vue")
  },
  {
    name: "exercise",
    path: "/exercise",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/exercise/index.vue")
  },
  {
    name: "magazine",
    path: "/magazine",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/index.vue")
  },
  {
    name: "password",
    path: "/password",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/password/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/register/index.vue")
  },
  {
    name: "about-terms-mbg",
    path: "/about/terms/mbg",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/mbg.vue")
  },
  {
    name: "password-verify",
    path: "/password/verify",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/password/verify.vue")
  },
  {
    name: "products-zotrim",
    path: "/products/zotrim",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/zotrim.vue")
  },
  {
    name: "register-verify",
    path: "/register/verify",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/register/verify.vue")
  },
  {
    name: "about-affiliates",
    path: "/about/affiliates",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/affiliates.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/challenges/index.vue")
  },
  {
    name: "magazine-request",
    path: "/magazine/request",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/request.vue")
  },
  {
    name: "about-terms",
    path: "/about/terms",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/users/index.vue")
  },
  {
    name: "discussions",
    path: "/discussions",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/index.vue")
  },
  {
    name: "products-phengold",
    path: "/products/phengold",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/phengold.vue")
  },
  {
    name: "products-testogen",
    path: "/products/testogen",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/testogen.vue")
  },
  {
    name: "products-trimtone",
    path: "/products/trimtone",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/trimtone.vue")
  },
  {
    name: "about-terms-cancel",
    path: "/about/terms/cancel",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/cancel.vue")
  },
  {
    name: "about-terms-refund",
    path: "/about/terms/refund",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/refund.vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/users/create.vue")
  },
  {
    name: "products-blackwolf",
    path: "/products/blackwolf",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/blackwolf.vue")
  },
  {
    name: "about-terms-privacy",
    path: "/about/terms/privacy",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/privacy.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/reviews/index.vue")
  },
  {
    name: "products-berbaprime",
    path: "/products/berbaprime",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/berbaprime.vue")
  },
  {
    name: "products-primeshred",
    path: "/products/primeshred",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/primeshred.vue")
  },
  {
    name: "about-terms-shipping",
    path: "/about/terms/shipping",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/shipping.vue")
  },
  {
    name: "admin-reviews-create",
    path: "/admin/reviews/create",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/reviews/create.vue")
  },
  {
    name: "admin-redirects",
    path: "/admin/redirects",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/redirects/index.vue")
  },
  {
    name: "products-mindvitality",
    path: "/products/mindvitality",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/mindvitality.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/notifications.vue")
  },
  {
    name: "admin-redirects-create",
    path: "/admin/redirects/create",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/admin/redirects/create.vue")
  },
  {
    name: "about-subscriptions-faq",
    path: "/about/subscriptions-faq",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue")
  },
  {
    name: "discussions-forum-new",
    path: "/discussions/:forum()/new",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue")
  },
  {
    name: "goto-resource-id",
    path: "/goto/:resource([^/]*)*/:id()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue")
  },
  {
    name: "profile-username",
    path: "/profile/:username()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/profile/[username]/index.vue")
  },
  {
    name: "about-terms-subscriptions",
    path: "/about/terms/subscriptions",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue")
  },
  {
    name: "discussions-forum",
    path: "/discussions/:forum()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue")
  },
  {
    name: "products-buy-product",
    path: "/products/buy/:product(.*)*",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/buy/[...product].vue")
  },
  {
    name: "magazine-category",
    path: "/magazine/:category(.*)*",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue")
  },
  {
    name: "products-category",
    path: "/products/:category(.*)*",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/index.vue")
  },
  {
    name: "discussions-forum-handle",
    path: "/discussions/:forum()/:handle()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue")
  },
  {
    name: "magazine-category-article-article",
    path: "/magazine/:category([^/]*)*/article/:article()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue")
  },
  {
    name: "products-category-product-handle",
    path: "/products/:category([^/]*)*/product/:handle()",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue")
  },
  {
    name: "products-category-product-handle-reviews",
    path: "/products/:category([^/]*)*/product/:handle()/reviews",
    component: () => import("/codebuild/output/src1048356512/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue")
  }
]